import React, { useState } from "react";
import './Sidebar.css';
import dashboard_img from "../../Assets/images/dashboard-icon.png"

import { useLocation, useNavigate } from "react-router-dom";
import sidebarlogo from '../../Assets/images/logo.png';
import { Datalibrary, Datalibrarytwo, Inspection, Projects, Projectstwo, UserManagementIcon, UserManagementIcontwo, Template, Templatetwo, Inspectiontwo, Dashboard } from "../../Utils/Icons/Icons";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../Redux/Slice/Loader/loaderSlice";
import { } from "react-redux";

const drawerWidth = 240;

const Sidebar = ({ isCollapsed, toggleSidebar }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const handleNavigation = (url) => {
    dispatch(showLoader());

    navigate(url);
    dispatch(hideLoader());
  };

  const role_name = useSelector(
    (state) => state.auth?.user?.data?.body?.data?.role_name
  );

  return (
    <>
      <div className={`sidebar ${isCollapsed ? "sidebar-visible" : ""}`}>
        <div className="sidebar-inner d-flex flex-column align-items-center">
          <div className="sidebar-logo text-center">
            <img src={sidebarlogo} alt="sidebar-logo"></img>
          </div>

          <div className="hamburger-icon-sidebar d-none" onClick={toggleSidebar}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style={{ enableBackground: "new 0 0 512 512" }}
            >
              <g>
                <path
                  fill="#000000"
                  fillRule="evenodd"
                  d="M5 17.586a1 1 0 1 0 1.415 1.415L12 13.414 17.586 19A1 1 0 0 0 19 17.586L13.414 12 19 6.414A1 1 0 0 0 17.585 5L12 10.586 6.414 5A1 1 0 0 0 5 6.414L10.586 12z"
                  clipRule="evenodd"
                  opacity="1"
                />
              </g>
            </svg>
          </div>
          <ul className="sidebar-items p-0">

            {/* admin dashboard */}
            {role_name === "OFFICE_ADMIN" || role_name === "INSPECTOR"
              ? (
                <div>

                </div>)
              : (
                <li
                  className={`sidebar-item
                ${location.pathname.startsWith("/dashboard")
                      ? "active" : ""}`}
                  onClick={() => handleNavigation("/dashboard")}
                >
                  <a className="full-link desktop-view">
                    <span ><img src={dashboard_img} alt="dashboard_img" className="dashboard_img"></img></span>
                    Dashboard
                  </a>
                  <a className="tooltip-container-sidebar full-link icon-view">
                    <span><img src={dashboard_img} alt="dashboard_img" className="dashboard_img2"></img></span>
                    <span className="tooltip-text-sidebar">Dashboard</span>
                  </a>
                </li>)}

            {/* project management */}
            <li
              className={`sidebar-item
                ${location.pathname.startsWith("/project-listing") ||
                  location.pathname.startsWith("/view-project") ||
                  location.pathname.startsWith("/update-project")
                  ? "active" : ""}`}
              onClick={() => handleNavigation("/project-listing")}
            >
              <a className="full-link desktop-view">
                <span><Projects /></span>
                Projects
              </a>
              <a className="tooltip-container-sidebar full-link icon-view">
                <span><Projectstwo /></span>
                <span className="tooltip-text-sidebar">Projects</span>
              </a>
            </li>

            {/* inspection management */}
            <li
              className={
                `sidebar-item 
                ${location.pathname.startsWith("/inspection-listing") ||
                  location.pathname.startsWith("/add-inspection") ||
                  location.pathname.startsWith("/update-inspection")
                  ? "active" : ""}`
              }
              onClick={() => handleNavigation("/inspection-listing")}
            >
              <a className="full-link desktop-view">
                <span><Inspection /></span>
                Inspection
              </a>
              <a className="tooltip-container-sidebar full-link icon-view">
                <span><Inspectiontwo /></span>
                <span className="tooltip-text-sidebar">Inspection</span>
              </a>
            </li>

            {/* template management */}
            <li
              className={
                `sidebar-item 
                ${location.pathname.startsWith("/template-listing") ||
                  location.pathname.startsWith("/add-template") ||
                  location.pathname.startsWith("/update-template")
                  ? "active" : ""}`
              }
              onClick={() => handleNavigation("/template-listing")}
            >
              <a className="full-link desktop-view">
                <span>
                  <Template></Template>
                </span>
                Template
              </a>
              <a className="tooltip-container-sidebar full-link icon-view">
                <span>
                  <Templatetwo></Templatetwo>
                </span>
                <span className="tooltip-text-sidebar">Template</span>
              </a>
            </li>


            {/* data library */}
            <li
              className={
                `sidebar-item 
                ${location.pathname.startsWith("/datalibrary-listing") ||
                  location.pathname.startsWith("/add-datalibrary") ||
                  location.pathname.startsWith("/update-datalibrary")
                  ? "active" : ""}`
              }
              onClick={() => handleNavigation("/datalibrary-listing")}
            >
              <a className="full-link desktop-view">
                <span><Datalibrary /></span>
                Data Library
              </a>
              <a className="tooltip-container-sidebar full-link icon-view">
                <span><Datalibrarytwo /></span>
                <span className="tooltip-text-sidebar">Data Library</span>

              </a>
            </li>

            {/* template log restricted for inspector and office admin */}
            {role_name === "OFFICE_ADMIN" || role_name === "INSPECTOR"
              ? (
                <div>

                </div>)
              : (
                <li
                  className={
                    `sidebar-item 
                ${location.pathname.startsWith("/template-logs") ||
                      location.pathname.startsWith("/view-template-logs")
                      ? "active" : ""}`
                  }
                  onClick={() => handleNavigation("/template-logs")}
                >
                  <a className="full-link desktop-view">
                    <span>
                      <Template></Template>
                    </span>
                    Template Logs
                  </a>
                  <a className="tooltip-container-sidebar full-link icon-view">
                    <span>
                      <Templatetwo></Templatetwo>
                    </span>
                    <span className="tooltip-text-sidebar">Template Logs</span>
                  </a>
                </li>
              )
            }

            {role_name === "OFFICE_ADMIN" || role_name === "INSPECTOR"
              ? (
                <div></div>)
              : (
                <>
                <li
                  className={
                    `sidebar-item 
                ${location.pathname.startsWith("/audit-logs") ||
                      location.pathname.startsWith("/view-audit-logs")
                      ? "active" : ""}`
                  }
                  onClick={() => handleNavigation("/audit-logs")}
                >
                  <a className="full-link desktop-view">
                    <span>
                      <Template></Template>
                    </span>
                    Audit Logs
                  </a>
                  <a className="tooltip-container-sidebar full-link icon-view">
                    <span>
                      <Templatetwo></Templatetwo>
                    </span>
                    <span className="tooltip-text-sidebar">Audit Logs</span>
                  </a>
                </li>
                </>
              )
            }

            {/* user management restricted for inspector and office admin */}
            {role_name === "OFFICE_ADMIN" || role_name === "INSPECTOR" ?
              <div></div> :
              (
                <li
                  className={`sidebar-item 
                ${location.pathname.startsWith("/user-listing") ||
                      location.pathname.startsWith("/view-user") ||
                      location.pathname.startsWith("/update-user")
                      ? "active" : ""}`}
                  onClick={() => handleNavigation("/user-listing")}
                >
                  <a className="full-link desktop-view">
                    <span><UserManagementIcon /></span>
                    User Management
                  </a>
                  <a className="tooltip-container-sidebar full-link icon-view">
                    <span><UserManagementIcontwo /></span>
                    <span className="tooltip-text-sidebar">User Management</span>
                  </a>
                </li>
              )
            }
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
